
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrderProductSpecificationsDialog extends Serenity.EntityDialog<OrderProductSpecificationsRow, any> {
        protected getFormKey() { return OrderProductSpecificationsForm.formKey; }
        protected getIdProperty() { return OrderProductSpecificationsRow.idProperty; }
        protected getLocalTextPrefix() { return OrderProductSpecificationsRow.localTextPrefix; }
        protected getService() { return OrderProductSpecificationsService.baseUrl; }
        protected getDeletePermission() { return OrderProductSpecificationsRow.deletePermission; }
        protected getInsertPermission() { return OrderProductSpecificationsRow.insertPermission; }
        protected getUpdatePermission() { return OrderProductSpecificationsRow.updatePermission; }

        protected form = new OrderProductSpecificationsForm(this.idPrefix);

    }
}